/*
  getRandomId.js
*/

const CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

/**
 * Gets a random 8-digit string.
 */
export default function getRandomId(len = 8) {
  let str = '';
  for (let i = 0; i < len; i++) {
    str += CHARS[Math.floor(Math.random() * CHARS.length)];
  }
  return str;
}
